const getTextToReturn = (amount: number, amountType: string) =>
    `confirming your online earnings in ${amount} ${amountType}.`;

export const getConfirmationDrawerText = (hours: number) => {
    switch (true) {
        case hours <= 0:
            return `confirmation typically within 24 hours.`;
        case hours <= 24:
            return getTextToReturn(24, 'hours');
        case hours <= 48:
            return getTextToReturn(48, 'hours');
        case hours <= 72:
            return getTextToReturn(72, 'hours');
        case hours <= 168:
            return getTextToReturn(7, 'days');
        case hours <= 672:
            return getTextToReturn(30, 'days');
        case hours > 672:
            return getTextToReturn(60, 'days');
        default:
            return `confirmation typically within 24 hours.`;
    }
};
